import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "No.svg",
  "use": "No.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"No.svg\"><path d=\"M32.01,56.021a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.021ZM16.5213,19.3732A19.9962,19.9962,0,0,0,44.6578,47.51ZM52.0108,32.0209A19.9971,19.9971,0,0,0,19.35,16.5411l28.14,28.14A19.9135,19.9135,0,0,0,52.0108,32.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol